import React, { useState, useEffect } from "react"
import styled from "styled-components"
import Spinner from "../../images/meets/Spinner.gif"
import { Row, Col, Card, InputGroup, FormControl, Image } from "react-bootstrap"
import { Link } from "gatsby"
import Parser from "html-react-parser"
import { saveLead, checkEmail } from "../../utils/emails"
import { PayPalButton } from "react-paypal-button-v2"
import techoImgOne from "../../images/techo/01.jpg"
import techoImgTwo from "../../images/techo/02.jpg"
import techoImgThree from "../../images/techo/04.jpg"

export let Techo = props => {
  return (
    <>
      <section style={{ paddingBottom: "4rem" }}>
        <RowTecho className="row justify-content-md-center">
          <RowText>
            <h1 style={{ fontSize: "3rem" }}>
              {" "}
              <b>Conoce TECHO </b>
            </h1>
          </RowText>
          <RowText>
            <p>
              es una Fundación sin fines de lucro, que combate la exclusión. Han
              llevado a 140 comunidades de 10 regiones de Chile viviendas
              definitivas, que permiten a las personas compartir en comunidad y
              con acceso a servicios básicos, salud, educación y transporte.
            </p>
          </RowText>
          <Row
            style={{ marginTop: "4rem", justifyContent: "space-between" }}
            className=" justify-content-md-center"
          >
            <Col xl={4} style={{ paddingBottom: "25px" }}>
              <Image src={techoImgOne} fluid></Image>
            </Col>
            <Col xl={4} style={{ paddingBottom: "25px" }}>
              <Image src={techoImgTwo} fluid></Image>
            </Col>
            <Col xl={4} style={{ paddingBottom: "25px" }}>
              <Image src={techoImgThree} fluid></Image>
            </Col>
          </Row>
        </RowTecho>
      </section>
    </>
  )
}

const RowTecho = styled.div`
  padding-left: 200px;
  padding-right: 200px;
  margin-top: 2rem;

  @media (max-width: 900px) {
    padding-left: 50px;
    padding-right: 50px;
  }
  @media (max-width: 502px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`
const BtnSend = styled.button`
  background-color: #efefef !important;
  padding: 1rem 2rem 1rem 2rem;
  border-radius: 6px;
  border-width: 0;
  :active {
    background-color: #efefef !important;
  }
  :hover {
    background-color: #efefef !important;
  }
  :visited {
    background-color: #efefef !important;
  }
  :link {
    background-color: #efefef !important;
  }
`
const InputAmount = styled.input`
  padding: 1rem 2rem 1rem 1rem;
  margin-right: 2rem;
  border-radius: 6px;
  border-width: 0;
  @media (max-width: 502px) {
    margin-right: 0;
    margin-bottom: 2rem;
    padding: 1rem 5rem 1rem 1rem;
  }
  @media (max-width: 339px) {
    padding: 1rem 3rem 1rem 1rem;
  }
`
const RowText = styled.div`
  margin-right: auto;
  margin-left: auto;
  justify-content: center !important;
  width: 100%;

  p {
    text-align: center !important;
    font-size: 1.4rem;
  }
  h1 {
    text-align: center !important;
  }
  h2 {
    text-align: center !important;
    font-family: "Poppins", sans-serif;
    font-size: 1.5rem !important;
  }
  a {
    color: white;
    font-family: "Poppins", sans-serif;
    font-size: 1.5rem !important;
    font-weight: bold;
  }
`
const ImputMail = styled.input`
  padding: 1rem 4rem 1rem 1rem;
  margin-right: 2rem;
  border-radius: 6px;
  border-width: 0;
  @media (max-width: 502px) {
    margin-right: 0;
    margin-bottom: 2rem;
    padding: 1rem 5rem 1rem 1rem;
  }
  @media (max-width: 339px) {
    padding: 1rem 3rem 1rem 1rem;
  }
`
const Title = styled.h2`
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  line-height: 1.2;
  padding-top: 2rem;
  padding-bottom: 3rem;
  font-size: 3rem;
  text-align: center;
  margin-top: 4rem;
  @media (max-width: 600px) {
    font-size: 2rem;
    padding-bottom: 2rem;
  }
  @media (max-width: 400px) {
    font-size: 1.3rem;
    margin-top: 2rem;
    padding-bottom: 1rem;
  }
`
const SubTitle = styled.h4`
  font-family: "Poppins", sans-serif;
  text-align: center;
  margin-bottom: 4rem;
  @media (max-width: 600px) {
    font-size: 1.3rem;
  }
`
export default Techo
